import React from "react";
import ReactDOM from "react-dom/client";
import Privacy from "./privacy";
import "../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Privacy />
  </React.StrictMode>,
);
